const T = require('prop-types');
const { makeActionCreator } = require('../utils/redux-helpers');
const { WELCOME_PAGE_MANAGEMENT: Types } = require('../action-types');

module.exports = (context) => {

    const api = context.api.nearpeer;
    const actions = context.actions;
    const selectors = context.selectors.all;

    return {
        fetchSettings: makeActionCreator(Types.FETCH_SETTINGS, {}, {
            async: api.welcomePage.getSettings
        }),
        updateSchoolText: makeActionCreator(Types.UPDATE_SCHOOL_TEXT, {
            homeText: T.string,
            roleHomeTextEnabled: T.bool
        }, {
            async: api.welcomePage.updateSchoolText,
            after: ({ dispatch, getState }) => {

                dispatch(actions.alerts.notification.push({ message: 'Welcome page message updated' }));
                dispatch(actions.dataFetching.fetchCurrentUser());

                const schoolId = selectors.getCurrentSchoolId(getState());

                if (schoolId) {
                    dispatch(actions.dataFetching.fetchAppEntities({ entities: ['schoolDetails'], schoolId }));
                }
            }
        }),
        updateRoleText: makeActionCreator(Types.UPDATE_ROLE_TEXT, {
            roleId: T.number,
            homeText: T.string
        }, {
            async: api.welcomePage.updateRoleText,
            after: ({ dispatch, getState }) => {

                dispatch(actions.alerts.notification.push({ message: 'Role welcome message updated' }));

                const schoolId = selectors.getCurrentSchoolId(getState());

                dispatch(actions.dataFetching.fetchAppEntities({ entities: ['roles'], schoolId }));
            }
        })
    };
};
